/**
 * Shows a spinner element by removing the 'd-none' class and adding the 'd-flex' class.
 * This function assumes the spinner element is initially hidden with 'd-none'.
 *
 * @param {string} spinnerId - The ID of the spinner element to be shown.
 */
export function showSpinner(spinnerId) {
    const spinner = document.getElementById(spinnerId);
    if (spinner) {
        spinner.classList.remove('d-none');
        spinner.classList.add('d-flex');
    }
}

/**
 * Hides a spinner element by adding the 'd-none' class and removing the 'd-flex' class.
 * This function assumes the spinner element is initially visible with 'd-flex'.
 *
 * @param {string} spinnerId - The ID of the spinner element to be hidden.
 */
export function hideSpinner(spinnerId) {
    const spinner = document.getElementById(spinnerId);
    if (spinner) {
        spinner.classList.add('d-none');
        spinner.classList.remove('d-flex');
    }
}
